module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hr",
    staticStyle: {
      "margin-top": "60px"
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', [_vm._v("normal")]), _vm._v(" "), _c('mt-hr')], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', [_vm._v("weight 4px")]), _vm._v(" "), _c('mt-hr', {
    attrs: {
      "height": "4px",
      "margin": "10px 0"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', [_vm._v("primary")]), _vm._v(" "), _c('mt-hr', {
    attrs: {
      "background": "#52C7CA"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', [_vm._v("warning")]), _vm._v(" "), _c('mt-hr', {
    attrs: {
      "background": "#FFB950"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', [_vm._v("danger")]), _vm._v(" "), _c('mt-hr', {
    attrs: {
      "background": "#F26666"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bab64dd","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/hr.vue
// module id = 533
// module chunks = 0